/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Clear_SelectionInputs */

const en_table_clear_selection = /** @type {(inputs: Table_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

const es_table_clear_selection = /** @type {(inputs: Table_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar seleccion`)
};

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Table_Clear_SelectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_clear_selection = /** @type {((inputs?: Table_Clear_SelectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Clear_SelectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_clear_selection(inputs)
	return es_table_clear_selection(inputs)
});